import { generateGruserObjectId } from '../redux/helpers';

export type GruserObjectId = ReturnType<typeof generateGruserObjectId>;

export enum GruserType {
  'Deviation' = 1,
  'Profile' = 4,
}
